<template>
  <div :id="'project-inq'+projectIdx" class="dvClientFormBox">
    <div class="dvClientFormBox-header valign-wrapper">
      <div class="dvClientFormBox-header-title">
        Project Inquiry {{ projectsCnt > 1 ? projectIdx + 1 : '' }}
      </div>
      <a
        v-if="client.archive != 1"
        @click="edit"
        href="javascript:void(0)" class="dvClientFormBox-header-btn btn waves-effect waves-light flexCenterAll">edit <span class="icon-action_edit"></span></a>
    </div>
    <div class="dvClientFormBox-content">
      <div class="row">
        <form class="col s12">
          <div class="row">
            <div class="col l4 m12 s12">
              <div class="dvClientFormBox-content-item">
                <v-text-field
                  v-model="projectInquiryDetails.property"
                  disabled
                  label="Project Interested In"
                  prepend-icon="icon-content_project">
                </v-text-field>
              </div><!-- dvClientFormBox-content-item -->
            </div><!-- col -->

            <div class="col l4 m12 s12">
              <div class="dvClientFormBox-content-item">
                <v-text-field
                  v-model="projectInquiryDetails.project_location_name"
                  disabled
                  prepend-icon="icon-content_location"
                  label="Project Location">
                </v-text-field>
              </div><!-- dvClientFormBox-content-item -->
            </div><!-- col -->            

          </div><!-- row -->
        </form><!-- form -->
      </div><!-- row -->
    </div><!-- dvClientFormBox-content -->
  </div> <!-- dvClientFormBox -->
</template>

<script>
  import M from 'materialize-css'

  export default {
    name: 'project-info',
    props: ['projectIdx', 'projectsCnt', 'projectInquiryDetails', 'projectData', 'client'],
    data: () => ({

    }),
    methods: {
      edit (){
        this.$emit('editProject', this.projectIdx);
      }
    },
    mounted() {
      var elems = document.querySelectorAll('select');
      M.FormSelect.init(elems);
    }
  }
</script>
